/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react'
import { dateCol, dateTimeCol, strCol } from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import {
  getSolarDays,
  saveSolarDays,
  deleteSolarDays,
  solarPlantDetails,
} from 'api/pgads.js'
import { calculateSunriseSunset } from './SolarDaysCreationJob'
import { getApiTargetInfo } from '../../../src/core'
import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, Select, DatePicker, message } from 'antd'
import { HistoryModal, RenameModal } from './SolarStorageGroup'
import { ErrorContext, JcTmpErrorContext } from 'context'
import moment from 'moment'
import R from 'ramda'
import { data } from 'table-utils/reducers'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'

const curYear = new Date().getFullYear()
const yearOption = R.range(curYear - 18, curYear + 4)
  .sort((a, b) => b - a)
  .map(i => (
    <Select.Option value={i} key={i}>
      {i}
    </Select.Option>
  ))

const getMap = (data, key, value) => {
  return R.compose(
    R.fromPairs,
    R.map(d => [d[key], d[value]])
  )(data)
}

const getTimeZoneOffset = timeZone => {
  if (!timeZone) return -5
  if (timeZone.startsWith('E')) return -5
  if (timeZone.startsWith('C')) return -6
  if (timeZone.startsWith('M')) return -7
  if (timeZone.startsWith('P')) return -8
  return -5
}

const SolarDaysCreation = ({ targetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const [plantMap, setPlantMap] = useState({})
  const [plantSelected, setPlantSelected] = useState([])
  const [plantSelectedForRetrieve, setPlantSelectedForRetrieve] = useState('')
  const [year, setYear] = useState(curYear)
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment().startOf('year'),
    moment().endOf('year'),
  ])

  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      // make sort plantName
      solarPlantDetails(targetInfo).fork(setError, data => {
        const sd = R.sortBy(R.prop('plantName'), data)
        setPlantSelectionData(
          sd?.map(plant => ({
            ...plant,
            timeZone: getTimeZoneOffset(plant.timeZone),
          }))
        )
        setPlantMap(getMap(sd, 'plantId', 'plantName'))
        if (!plantSelectedForRetrieve && sd[0] && sd[0].plantId)
          setPlantSelectedForRetrieve(sd[0].plantId)
      })
    },
    [targetInfo, setError, plantSelectedForRetrieve]
  )
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <>
        <Select
          showSearch
          value={plantSelectedForRetrieve}
          style={{ width: '250px', marginLeft: '10px' }}
          onChange={plantId => {
            setPlantSelectedForRetrieve(plantId)
            onChange()
            //  clearData()
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {plantSelectionData?.map(({ plantName, plantId }) => (
            <Select.Option key={plantId} value={plantId}>
              {plantName}
            </Select.Option>
          ))}
        </Select>
        <DatePicker.RangePicker
          style={{ width: '240px', marginLeft: '10px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            onChange()
            // retrieve({ dates: d })
          }}
        />
      </>
    )
  }

  const handleCreateData = () => {
    if (plantSelected.length === 0) {
      message.error('Please, Select plant')
    } else {
      const effectivePlant = plantSelectionData?.filter(plant =>
        plantSelected.includes(plant.plantId)
      )
      const result = []
      effectivePlant
        .filter(plant => plant?.latitude && plant?.longitude)
        .forEach(plant => {
          const data = calculateSunriseSunset(
            plant.latitude,
            plant.longitude > 0 ? plant.longitude * -1 : plant.longitude,
            year,
            12.0,
            plant.timeZone,
            plant.plantId,
            plant.entityId,
            plant.daylightSaving
          )
          result.push(...data) // Spread operator to push all elements at once
        })
      saveSolarDays(targetInfo)(result).fork(setError, data => {
        if (isErrorContains(data)) {
          setError(data)
        } else {
          message.info('Data saved.')
          setTmpError(data, _ => {})
        }
      })
    }
  }

  const beforeRetrieveValidation = () => {
    if (!plantSelectedForRetrieve) {
      message.error('Please, Select plant')
      return false
    }
    return true
  }

  const headerWithFormatter = SolarDaysHeaders.map(header =>
    header.ident === 'plantId'
      ? {
          ...header,
          dataFormatter: ({ value }) =>
            plantMap[value] ? value + '-' + plantMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            plantMap[rowData.plantId] || rowData.plantId,
          width: 250,
        }
      : header
  )

  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 360px 100px 150px 150px 150px',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Plant :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          showSearch
          value={plantSelected}
          style={{ width: '350px', marginLeft: '10px' }}
          onChange={plantId => {
            setPlantSelected(plantId)
          }}
          mode="multiple"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {plantSelectionData?.map(plant => (
            <Select.Option key={plant?.plantId} value={plant?.plantId}>
              {plant?.plantName}
            </Select.Option>
          ))}
        </Select>
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Year :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          id="year"
          style={{ minWidth: '90px' }}
          value={year}
          onChange={year => {
            setYear(year)
          }}
        >
          {yearOption}
        </Select>

        <Button type="primary" onClick={handleCreateData}>
          Create Data
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title="Solar Days"
      beforeRetrieveValidation={beforeRetrieveValidation}
      screenCriteria={screenCriteria}
      header={headerWithFormatter}
      sortOptions={SolarDaysHeaders}
      retrieveTask={getSolarDays}
      deleteTask={deleteSolarDays}
      saveTask={saveSolarDays}
      withCriteria={() => ({
        plantId: plantSelectedForRetrieve,
        startDate: selectedDateRangePicker[0],
        endDate: selectedDateRangePicker[1],
      })}
      showDatePickerOnEdit
      //   autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // totalWidth={850}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarDaysCreation)

const SolarDaysHeaders = [
  strCol({
    ident: 'entityId',
    display: 'Entity Id',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant Name',
    isRequired: true,
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'transDate',
    display: 'TransDate',
    isRequired: true,
    width: 250,
    isKey: true,
    sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'sunrise',
    display: 'Sunrise',
    isRequired: true,
    width: 250,
  }),
  dateTimeCol({
    ident: 'sunset',
    display: 'Sunset',
    isRequired: true,
    width: 250,
  }),

  modifierCol,
  modifiedDateCol,
]
